import React from 'react';
import {useQuery} from "@tanstack/react-query";
import {fetchLastReports} from "../api/reportApi";
import {Link, useParams} from "react-router-dom";
import {ListGroup, Spinner, Alert} from "react-bootstrap";
import {format} from "date-fns";

export function LastReports() {
  const { report } = useParams();
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['last-reports', report],
    queryFn: fetchLastReports,
    staleTime: 1000 * 3600
  });

  if (isLoading) {
    return (
      <div className="text-center p-3">
        <Spinner animation="border" size="sm" />
      </div>
    );
  }

  if (isError) {
    return (
      <Alert variant="danger" className="m-3">
        Error loading last reports: {error.message}
      </Alert>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="text-center p-3 text-muted">
        No reports found.
      </div>
    );
  }

  return (
    <ListGroup variant="flush">
        {data.map(report_data => (
            <ListGroup.Item key={report_data.id} className="py-3">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h6 className="mb-1">
                    {report_data.file_size_or_zero > 0 ? (
                      <a href={`/api/reports/runs/${report_data.id}/download`} className="text-decoration-none">
                        {report_data.name}
                      </a>
                    ) : (
                      <span>{report_data.name}</span>
                    )}
                  </h6>
                  <div className="small text-muted">
                    {format(new Date(report_data.created), 'P p')}
                    {report_data.file_size_or_zero > 0 && (
                      <span className="ms-2">
                        • {Math.round(report_data.file_size_or_zero / 1024 / 1024 * 100) / 100} MB
                      </span>
                    )}
                  </div>
                </div>
                <span className={`badge ${report_data.file_size_or_zero > 0 ? 'bg-success' : 'bg-info'}`}>
                  {report_data.status}
                </span>
              </div>
            </ListGroup.Item>
        ))}
    </ListGroup>
  );
}
